const $ = window.jQuery;
const ajaxurl = window.ajaxurl;
const wpmdb_strings = window.wpmdb_strings;
const wpmdb_data = window.wpmdb_data;

export default class WPMDBGlobals {
	constructor() {
		this.show_ssl_notice = false;
		this.doing_save_profile = false;
		this.doing_ajax = false;
		this.profile_name_edited = false;
		this.migration_intent = null;
		this.doing_licence_registration_ajax = false;
		this.migration_paused = false;
		this.last_replace_switch = wpmdb.functions.wpmdb_migration_type();
		this.connection_established = false;
		this.profile_name_edited = false;
		this.checked_licence = false;
		this.show_prefix_notice = false;
		this.show_ssl_notice = false;
		this.force_reconnect = false;
		this.migration_selection = '';
		this.show_version_notice = false;
		this.migration_completed = false;
		this.currently_migrating = false;
		this.dump_filename = '';
		this.dump_path = '';
		this.migration_intent = '';
		this.remote_site = null;
		this.secret_key = null;
		this.form_data = null;
		this.stage = null;
		this.elapsed_interval = null;
		this.completed_msg = null;
		this.tables_to_migrate = [];
		this.migration_paused = false;
		this.previous_progress_title = '';
		this.previous_progress_text_primary = '';
		this.previous_progress_text_secondary = '';
		this.cancelling_text = '';
		this.paused_text = '';
		this.migration_cancelled = false;
		this.flag_skip_delay = false;
		this.delay_between_requests = 0;
		this.fade_duration = 400;
		this.pause_before_finalize = false;
		this.is_auto_pause_before_finalize = false;
		this.$connection_info_box = $( '.connection-info-wrapper' );
		this.$push_select = window.wpmdb.$push_select = $( '#select-tables' ).clone();
		this.$pull_select = window.wpmdb.$pull_select = $( '#select-tables' ).clone();
		this.$push_post_type_select = $( '#select-post-types' ).clone();
		this.$pull_post_type_select = $( '#select-post-types' ).clone();
		this.$push_select_backup = $( '#select-backup' ).clone();
		this.$pull_select_backup = $( '#select-backup' ).clone();

		this.spinner_url = window.spinner_url = wpmdb.functions.get_spinner_url();
		this.ajax_spinner = window.ajax_spinner = '<img src="' + this.spinner_url + '" alt="" class="ajax-spinner general-spinner" />';
	}

	pad( n, width, z ) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array( width - n.length + 1 ).join( z ) + n;
	}

	is_int( n ) {
		n = parseInt( n );
		return 'number' === typeof n && 0 === n % 1;
	}

	get_intersect( arr1, arr2 ) {
		var r = [], o = {}, l = arr2.length, i, v;
		for ( i = 0; i < l; i++ ) {
			o[ arr2[ i ] ] = true;
		}
		l = arr1.length;
		for ( i = 0; i < l; i++ ) {
			v = arr1[ i ];
			if ( v in o ) {
				r.push( v );
			}
		}

		return r;
	}

	pin_replace_url( pin ) {
		if ( true === pin && 1 > $( '.replace-row.pin' ).length && 1 === $( '#old-url' ).length ) {
			$( '#old-url' ).parents( '.replace-row' ).addClass( 'pin' );
		}

		if ( false === pin && 0 < $( '.replace-row.pin' ).length ) {
			$( '.replace-row.pin' ).removeClass( 'pin' );
		}
	}

	/**
	 * Core plugin wrapper for the common AJAX error detecting method
	 *
	 * @param text
	 * @param code
	 * @param jqXHR
	 *
	 * @returns {string}
	 */
	get_ajax_errors( text, code, jqXHR ) {
		return wpmdb.functions.wpmdbGetAjaxErrors( wpmdb_strings.connection_local_server_problem, code, text, jqXHR );
	}

	// updates the debug log when the user switches to the help tab
	refresh_debug_log() {
		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			data: {
				action: 'wpmdb_get_log',
				nonce: wpmdb_data.nonces.get_log
			},
			error( jqXHR, textStatus, errorThrown ) {
				alert( wpmdb_strings.update_log_problem );
			},
			success( data ) {
				$( '.debug-log-textarea' ).val( data );
			}
		} );
	}

	get_query_var( name ) {
		name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
		var regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' ),
			results = regex.exec( location.search );
		return null === results ? '' : decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
	}

	maybe_show_ssl_warning( url, key, remote_scheme ) {
		var scheme = url.substr( 0, url.indexOf( ':' ) );
		var $ssl_notice = $( '.ssl-notice' );

		if ( !this.show_ssl_notice ) {
			$ssl_notice.hide();
		}

		if ( remote_scheme !== scheme && url.indexOf( 'https' ) !== -1 ) {
			$ssl_notice.show();
			this.show_ssl_notice = true;
			url = url.replace( 'https', 'http' );
			$( '.pull-push-connection-info' ).val( url + '\n' + key );
			return;
		}

		this.show_ssl_notice = false;
	}

	validate_url( url ) {
		return /^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test( url );
	}

	refresh_table_selects() {
		if ( undefined !== wpmdb_data && undefined !== wpmdb_data.this_tables && undefined !== wpmdb_data.this_table_sizes_hr ) {
			this.$push_select = this.create_table_select( wpmdb_data.this_tables, wpmdb_data.this_table_sizes_hr, $( wpmdb.$push_select ).val() );
		}

		if ( undefined !== wpmdb.common.connection_data && undefined !== wpmdb.common.connection_data.tables && undefined !== wpmdb.common.connection_data.table_sizes_hr ) {
			this.$pull_select = this.create_table_select( wpmdb.common.connection_data.tables, wpmdb.common.connection_data.table_sizes_hr, $( wpmdb.$pull_select ).val() );
		}
	}

	save_active_profile() {
		var profile;
		$( '.save-settings-button' ).blur();

		if ( this.doing_save_profile ) {
			return;
		}

		if ( true === this.maybe_show_select_table_notice() ) {
			return;
		}

		var create_new_profile = false;

		if ( $( '#create_new' ).is( ':checked' ) ) {
			create_new_profile = true;
		}
		var profile_name = $( '.create-new-profile' ).val();

		this.doing_save_profile = true;
		profile = $( $( '#migrate-form' )[ 0 ].elements ).not( '.auth-credentials' ).serialize();

		$( '.save-settings-button' ).attr( 'disabled', 'disabled' )
			.after( '<img src="' + this.spinner_url + '" alt="" class="save-profile-ajax-spinner general-spinner" />' );

		this.doing_ajax = true;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			data: {
				action: 'wpmdb_save_profile',
				profile: profile,
				nonce: wpmdb_data.nonces.save_profile
			},
			error: ( jqXHR, textStatus, errorThrown ) => {
				this.doing_ajax = false;
				alert( wpmdb_strings.save_profile_problem );
				$( '.save-settings-button' ).removeAttr( 'disabled' );
				$( '.save-profile-ajax-spinner' ).remove();
				$( '.save-settings-button' ).after( '<span class="ajax-success-msg">' + wpmdb_strings.saved + '</span>' );
				$( '.ajax-success-msg' ).fadeOut( 2000, function() {
					$( this ).remove();
				} );
				this.doing_save_profile = false;
			},
			success: ( data ) => {
				var updated_profile_id = parseInt( $( '#migrate-form input[name=save_migration_profile_option]:checked' ).val(), 10 ) + 1;
				this.doing_ajax = false;
				$( '.save-settings-button' ).removeAttr( 'disabled' );
				$( '.save-profile-ajax-spinner' ).remove();
				$( '.save-settings-button' ).after( '<span class="ajax-success-msg">' + wpmdb_strings.saved + '</span>' );
				$( '.ajax-success-msg' ).fadeOut( 2000, function() {
					$( this ).remove();
				} );
				this.doing_save_profile = false;
				$( '.create-new-profile' ).val( '' );

				if ( create_new_profile ) {
					var new_profile_key = parseInt( data, 10 );
					var new_profile_id = new_profile_key + 1;
					var new_li = $( '<li><span class="delete-profile" data-profile-id="' + new_profile_id + '"></span><label for="profile-' + new_profile_id + '"><input id="profile-' + new_profile_id + '" value="' + new_profile_key + '" name="save_migration_profile_option" type="radio"></label></li>' );
					new_li.find( 'label' ).append( document.createTextNode( ' ' + profile_name ) );
					updated_profile_id = new_profile_id;

					$( '#create_new' ).parents( 'li' ).before( new_li );
					$( '#profile-' + new_profile_id ).attr( 'checked', 'checked' );
				}

				// Push updated profile id to history if available
				var updated_url = window.location.href.replace( '#migrate', '' ).replace( /&wpmdb-profile=-?\d+/, '' ) + '&wpmdb-profile=' + updated_profile_id;
				var updated_profile_name = $( '#migrate-form input[name=save_migration_profile_option]:checked' ).parent().text().trim();

				if ( 'function' === typeof window.history.pushState ) {
					if ( $( '#migrate-form .crumbs' ).length ) {
						$( '#migrate-form .crumbs .crumb:last' ).text( updated_profile_name );
					} else {
						var $crumbs = $( '<div class="crumbs" />' )
							.append( '<a class="crumb" href="' + wpmdb_data.this_plugin_base + '"> Saved Profiles </a>' )
							.append( '<span class="crumb">' + updated_profile_name + '</span>' );
						$( '#migrate-form' ).prepend( $crumbs );
					}
					window.history.pushState( { updated_profile_id: updated_profile_id }, null, updated_url );
				}
			}
		} );
	}

	cancel_migration( event ) {
		this.migration_cancelled = true;
		this.cancelling_text = wpmdb_strings.cancelling_migration;
		$( '.migration-controls' ).css( { visibility: 'hidden' } );

		if ( 'find_replace' === this.migration_intent ) {
			this.cancelling_text = wpmdb_strings.cancelling_find_replace;
		}

		wpmdb.current_migration.setState( this.cancelling_text, wpmdb_strings.completing_current_request, 'cancelling' );

		if ( true === this.migration_paused ) {
			this.migration_paused = false;
			wpmdb.functions.execute_next_step();
		}
	}

	/**
	 * Set checkbox
	 *
	 * @param string checkbox_wrap
	 */
	set_checkbox( checkbox_wrap ) {
		const $switch = $( '#' + checkbox_wrap );
		var $checkbox = $switch.find( 'input[type=checkbox]' );

		$switch.toggleClass( 'on' ).find( 'span' ).toggleClass( 'checked' );
		var switch_on = $switch.find( 'span.on' ).hasClass( 'checked' );
		$checkbox.attr( 'checked', switch_on ).trigger( 'change' );
	}

	// save file (export) / push / pull special conditions
	move_connection_info_box() {
		var $connection_status = $( '.connection-status' );
		var $directory_permission_notice = $( '.directory-permission-notice' );
		var $compatibility_older_mysql = $( '.compatibility-older-mysql' );
		var $mst_required = $( '.mst-required' );
		var $keep_active_plugins = $( '.keep-active-plugins' );
		var $step_two = $( '.step-two' );
		var $backup_options = $( '.backup-options' );
		var new_migration_type = wpmdb.functions.wpmdb_migration_type();
		var profile_name, table_prefix, backup_table_prefix, uploads_dir, upload_dir_long, write_permission;

		$connection_status.hide();
		$directory_permission_notice.hide();
		$step_two.show();
		$backup_options.show();
		$keep_active_plugins.show();
		$compatibility_older_mysql.hide();
		$mst_required.hide();

		wpmdb.functions.wpmdb_toggle_migration_action_text();

		$( '.migrate-tab' ).attr( 'class', 'migrate-tab content-tab' ).addClass( wpmdb.functions.wpmdb_migration_type() );

		$.wpmdb.do_action( 'move_connection_info_box', {
			migration_type: new_migration_type,
			last_migration_type: this.last_replace_switch
		} );

		if ( -1 !== $.inArray( new_migration_type, [ 'push', 'pull' ] ) ) {
			var $pull_push_connection_info = $( '.pull-push-connection-info' );
			var connection_info = $.trim( $pull_push_connection_info.val() ).split( '\n' );
			var $migration_list_li = $( '.' + new_migration_type + '-list li' );

			$migration_list_li.append( this.$connection_info_box );
			this.$connection_info_box.show( function() {
				var connection_textarea = $( this ).find( '.pull-push-connection-info' );
				if ( !connection_textarea.val() ) {
					connection_textarea.focus();
				}
			} );

			// Reconnect if the migration type was just changed
			if ( new_migration_type !== this.last_replace_switch && 2 === connection_info.length ) {
				wpmdb.force_reconnect = true;
				$migration_list_li.append( this.$connection_info_box );
				$pull_push_connection_info.removeClass( 'temp-disabled' ).attr( 'readonly', 'readonly' );
				$( '.connect-button' ).hide();
				wpmdb.functions.connection_box_changed();
				return;
			}

			if ( this.connection_established ) {
				$connection_status.hide();
				$step_two.show();

				wpmdb.functions.wpmdb_toggle_migration_action_text();

				if ( 'pull' === new_migration_type ) {
					table_prefix = wpmdb.common.connection_data.prefix;
					backup_table_prefix = wpmdb_data.site_details.prefix;
					uploads_dir = wpmdb_data.this_uploads_dir;
					upload_dir_long = wpmdb_data.this_upload_dir_long;
					write_permission = wpmdb_data.write_permission;
				} else {
					table_prefix = wpmdb_data.this_prefix;
					backup_table_prefix = wpmdb.common.connection_data.prefix;
					uploads_dir = wpmdb.common.connection_data.uploads_dir;
					upload_dir_long = wpmdb.common.connection_data.upload_dir_long;
					write_permission = wpmdb.common.connection_data.write_permissions;
				}

				$( '.table_prefix' ).html( table_prefix );
				$( '.backup-table-prefix' ).html( backup_table_prefix );
				$( '.uploads-dir' ).html( uploads_dir );

				this.maybe_show_backup_disabled_msg( upload_dir_long, write_permission );

				if ( false === this.profile_name_edited ) {
					profile_name = this.get_domain_name( wpmdb.common.connection_data.url );
					$( '.create-new-profile' ).val( profile_name );
				}

			} else {
				$connection_status.show();
				$step_two.hide();
			}

		} else if ( -1 !== $.inArray( new_migration_type, [ 'find_replace', 'savefile' ] ) ) {
			$connection_status.hide();
			$step_two.show();
			$( '.table-prefix' ).html( wpmdb_data.this_prefix );
			if ( false === this.profile_name_edited ) {
				$( '.create-new-profile' ).val( '' );
			}

			$keep_active_plugins.hide();

			if ( 'savefile' === new_migration_type ) {
				$backup_options.hide();
				$compatibility_older_mysql.show();

				if ( 'false' === wpmdb_data.write_permission ) {
					$directory_permission_notice.show();
					$step_two.hide();
				}
			} else {
				if ( 'true' === wpmdb_data.is_multisite ) {
					var $old_replace_col = $( '.old-replace-col' ).eq( 1 );
					$old_replace_col.parent().removeClass( 'pin' ).find( '.replace-remove-row' ).show();
					$old_replace_col.find( 'input' ).removeAttr( 'readonly' );
				}

				this.maybe_show_backup_disabled_msg( wpmdb_data.this_upload_dir_long, wpmdb_data.write_permission );
			}
		}

		this.maybe_show_mixed_cased_table_name_warning();
	}

	maybe_show_backup_disabled_msg( upload_dir, write_permission ) {
		var $create_backup = $( '#create-backup' );
		var $create_backup_label = $( '#create-backup-label' );
		var $backup_option_disabled = $( '.backup-option-disabled' );

		$create_backup.removeAttr( 'disabled' );
		$create_backup_label.removeClass( 'disabled' );
		$backup_option_disabled.hide();

		if ( 'false' === write_permission ) {
			$create_backup.prop( 'checked', false );
			$create_backup.attr( 'disabled', 'disabled' );
			$create_backup_label.addClass( 'disabled' );
			$backup_option_disabled.show();
			$( '.upload-directory-location' ).html( upload_dir );
		}
	}

	change_replace_values() {
		var old_url = null;
		var old_path = null;

		const self = this;
		if ( null !== wpmdb.common.previous_connection_data && 'object' === typeof wpmdb.common.previous_connection_data && wpmdb.common.previous_connection_data.url !== wpmdb.common.connection_data.url ) {
			old_url = this.remove_protocol( wpmdb.common.previous_connection_data.url );
			old_path = wpmdb.common.previous_connection_data.path;
		}

		if ( 'push' === wpmdb.functions.wpmdb_migration_type() || 'savefile' === wpmdb.functions.wpmdb_migration_type() ) {
			if ( 'pull' === this.last_replace_switch ) {
				$( '.replace-row' ).each( function() {
					var old_val = $( '.old-replace-col input', this ).val();
					$( '.old-replace-col input', this ).val( $( '.replace-right-col input', this ).val() );
					$( '.replace-right-col input', this ).val( old_val );
				} );
			} else if ( 'push' === this.last_replace_switch && 'push' === wpmdb.functions.wpmdb_migration_type() && null !== old_url && null !== old_path ) {
				$( '.replace-row' ).each( function() {
					var old_val = $( '.replace-right-col input', this ).val();
					if ( old_val === old_path ) {
						$( '.replace-right-col input', this ).val( wpmdb.common.connection_data.path );
					}
					if ( old_val === old_url ) {
						$( '.replace-right-col input', this ).val( self.remove_protocol( wpmdb.common.connection_data.url ) );
					}
				} );
			}
			$.wpmdb.do_action( 'wpmdb_update_push_table_select' );
			$( '#select-post-types' ).remove();
			$( '.exclude-post-types-warning' ).after( this.$push_post_type_select );
			wpmdb.functions.exclude_post_types_warning();
			$( '#select-backup' ).remove();
			$( '.backup-tables-wrap' ).prepend( this.$push_select_backup );
		} else if ( 'pull' === wpmdb.functions.wpmdb_migration_type() ) {
			if ( '' === this.last_replace_switch || 'push' === this.last_replace_switch || 'savefile' === this.last_replace_switch ) {
				$( '.replace-row' ).each( function() {
					var old_val = $( '.old-replace-col input', this ).val();
					$( '.old-replace-col input', this ).val( $( '.replace-right-col input', this ).val() );
					$( '.replace-right-col input', this ).val( old_val );
				} );
			} else if ( 'pull' === this.last_replace_switch && 'pull' === wpmdb.functions.wpmdb_migration_type() && null !== old_url && null !== old_path ) {
				$( '.replace-row' ).each( function() {
					var old_val = $( '.old-replace-col input', this ).val();
					if ( old_val === old_path ) {
						$( '.old-replace-col input', this ).val( wpmdb.common.connection_data.path );
					}
					if ( old_val === old_url ) {
						$( '.old-replace-col input', this ).val( self.remove_protocol( wpmdb.common.connection_data.url ) );
					}
				} );
			}
			$.wpmdb.do_action( 'wpmdb_update_pull_table_select' );
			$( '#select-post-types' ).remove();
			$( '.exclude-post-types-warning' ).after( this.$pull_post_type_select );
			wpmdb.functions.exclude_post_types_warning();
			$( '#select-backup' ).remove();
			$( '.backup-tables-wrap' ).prepend( this.$pull_select_backup );
		}
		this.last_replace_switch = wpmdb.functions.wpmdb_migration_type();
	}

	switch_to_plugin_tab( hash, skip_addons_check ) {
		$( '.nav-tab' ).removeClass( 'nav-tab-active' );
		$( '.nav-tab.' + hash ).addClass( 'nav-tab-active' );
		$( '.content-tab' ).hide();
		$( '.' + hash + '-tab' ).show();

		if ( 'settings' === hash ) {
			if ( true === this.should_check_licence() ) {
				$( 'p.licence-status' ).append( 'Checking License... ' ).append( this.ajax_spinner );
				this.check_licence();
			}
		}

		if ( 'help' === hash ) {
			this.refresh_debug_log();
			if ( true === this.should_check_licence() ) {
				$( '.support-content p' ).append( this.ajax_spinner );
				this.check_licence();
			}
		}

		if ( 'addons' === hash && true !== skip_addons_check ) {
			if ( true === this.should_check_licence() ) {
				$( '.addons-content p' ).append( this.ajax_spinner );
				this.check_licence();
			}
		}
	}

	hide_overlay() {
		$( '#overlay' ).removeClass( 'show' ).addClass( 'hide' );
		$( '#overlay > div' ).removeClass( 'show' ).addClass( 'hide' );
		wpmdb.current_migration.$proVersion.find( 'iframe' ).remove();
		setTimeout( function() {
			$( '#overlay' ).remove();
		}, 500 );
		this.migration_completed = false;
	}

	check_licence( licence ) {
		var update_licence_content = !this.doing_licence_registration_ajax;
		this.checked_licence = true;
		let self = this;
		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'json',
			cache: false,
			data: {
				action: 'wpmdb_check_licence',
				licence: licence,
				context: 'all',
				nonce: wpmdb_data.nonces.check_licence
			},
			error( jqXHR, textStatus, errorThrown ) {
				alert( wpmdb_strings.license_check_problem );
			},
			success( data ) {

				var $support_content = $( '.support-content' );
				var $addons_content = $( '.addons-content' );
				var $licence_content = $( '.licence-status:not(.notification-message)' );
				var licence_msg, support_msg, addons_msg;

				if ( 'undefined' !== typeof data.dbrains_api_down ) {
					support_msg = data.dbrains_api_down + data.message;
					addons_msg = data.dbrains_api_down;
				} else if ( 'undefined' !== typeof data.errors ) {

					if ( 'undefined' !== typeof data.errors.subscription_expired ) {
						licence_msg = data.errors.subscription_expired.licence;
						support_msg = data.errors.subscription_expired.support;
						addons_msg = data.errors.subscription_expired.addons;
					} else {
						var msg = '';
						for ( var key in data.errors ) {
							msg += data.errors[ key ];
						}
						support_msg = msg;
						addons_msg = msg;
					}
					if ( 'undefined' !== typeof data.addon_content ) {
						addons_msg += '\n' + data.addon_content;
					}
				} else {
					support_msg = data.message;
					addons_msg = data.addon_content;
				}

				if ( update_licence_content ) {
					$licence_content.stop().fadeOut( self.fade_duration, function() {
						if ( 'undefined' === typeof licence_msg ) {
							$( this ).css( { visibility: 'hidden', display: 'block' } ).slideUp();
							licence_msg = '';
						}

						$( this )
							.empty()
							.html( licence_msg )
							.stop()
							.fadeIn( self.fade_duration );
					} );
				}

				$support_content.stop().fadeOut( self.fade_duration, function() {
					$( this )
						.empty()
						.html( support_msg )
						.stop()
						.fadeIn( self.fade_duration );
				} );
				$addons_content.stop().fadeOut( self.fade_duration, function() {
					$( this )
						.empty()
						.html( addons_msg )
						.stop()
						.fadeIn( self.fade_duration );
				} );

				if ( $( '#plugin-compatibility' ).is( ':not(:checked)' ) ) {
					$( '#compatibility-header' ).click();
				}
			}
		} );
	}

	should_check_licence() {
		return false === this.checked_licence && '1' === wpmdb_data.has_licence && 'true' === wpmdb_data.is_pro;
	}

	maybe_show_mixed_cased_table_name_warning() {
		if ( 'undefined' === typeof wpmdb.common.connection_data || false === wpmdb.common.connection_data ) {
			return;
		}

		var migration_intent = wpmdb.functions.wpmdb_migration_type();
		var tables_to_migrate = wpmdb.functions.get_tables_to_migrate( null, null );

		$( '.mixed-case-table-name-notice' ).hide();

		if ( null === tables_to_migrate ) {
			return;
		}

		tables_to_migrate = tables_to_migrate.join( '' );

		// The table names are all lowercase, no need to display the warning.
		if ( tables_to_migrate === tables_to_migrate.toLowerCase() ) {
			return;
		}

		/*
		 * Do not display the warning if the remote lower_case_table_names does not equal "1" (i.e the only problematic setting)
		 * Applies to push/export migrations.
		 */
		if ( '1' !== wpmdb.common.connection_data.lower_case_table_names && ('push' === migration_intent || 'savefile' === migration_intent) ) {
			return;
		}

		/*
		 * Do not display the warning if the local lower_case_table_names does not equal "1" (i.e the only problematic setting)
		 * Only applies to pull migrations.
		 */
		if ( '1' !== wpmdb_data.lower_case_table_names && 'pull' === migration_intent ) {
			return;
		}

		/*
		 * At this stage we've determined:
		 * 1. The source database contains at least one table that contains an uppercase character.
		 * 2. The destination environment has lower_case_table_names set to 1.
		 * 3. The source database table containing the uppercase letter will be converted to lowercase during the migration.
		 */

		if ( 'push' === migration_intent || 'savefile' === migration_intent ) {
			$( '.mixed-case-table-name-notice.push' ).show();
		} else {
			$( '.mixed-case-table-name-notice.pull' ).show();
		}
	}

	enable_pro_licence( data, licence_key ) {
		$( '.licence-input, .register-licence' ).remove();
		$( '.licence-not-entered' ).prepend( data.masked_licence );
		$( '.support-content' ).empty().html( '<p>' + wpmdb_strings.fetching_license + '<img src="' + this.spinner_url + '" alt="" class="ajax-spinner general-spinner" /></p>' );
		this.check_licence( licence_key );

		$( '.migrate-selection label' ).removeClass( 'disabled' );
		$( '.migrate-selection input' ).removeAttr( 'disabled' );
	}

	get_domain_name( url ) {
		var temp_url = url;
		var domain = temp_url.replace( /\/\/(.*)@/, '//' ).replace( 'http://', '' ).replace( 'https://', '' ).replace( 'www.', '' );
		return domain;
	}

	update_domain_placeholder( label, url, stage ) {
		var domain = this.get_domain_name( url );

		if ( 'completed' === stage ) {
			return label.replace( /\%s\s?/, '<span class=domain-label>' + domain + '</span>&nbsp;' );
		}

		return label.replace( /\%s(\S*)\s?/, '<span class=domain-label>' + domain + '$1</span>&nbsp;' );
	}

	get_migration_status_label( url, intent, stage ) {
		var migrating_stage_label = '';
		var completed_stage_label = '';

		switch ( intent ) {
			case 'push':
				migrating_stage_label = wpmdb_strings.push_migration_label_migrating;
				completed_stage_label = wpmdb_strings.push_migration_label_completed;
				break;
			case 'pull':
				migrating_stage_label = wpmdb_strings.pull_migration_label_migrating;
				completed_stage_label = wpmdb_strings.pull_migration_label_completed;
				break;
			case 'find_replace':
				migrating_stage_label = wpmdb_strings.find_replace_label_migrating;
				completed_stage_label = wpmdb_strings.find_replace_label_completed;
				break;
			case 'savefile':
				migrating_stage_label = wpmdb_strings.exporting_please_wait;
				completed_stage_label = wpmdb_strings.exporting_complete;
				break;
		}

		var label = migrating_stage_label;

		if ( 'completed' === stage ) {
			label = completed_stage_label;
		}

		if ( 'push' === intent || 'pull' === intent ) {
			label = this.update_domain_placeholder( label, url, stage );
		}

		label = $.wpmdb.apply_filters( 'wpmdb_get_migration_status_label', label, {
			intent: intent,
			stage: stage
		} );

		return label;
	}

	disable_export_type_controls() {
		$( '.option-group' ).each( function( index ) {
			$( 'input', this ).attr( 'disabled', 'disabled' );
			$( 'label', this ).css( 'cursor', 'default' );
		} );
	}

	enable_export_type_controls() {
		$( '.option-group' ).each( function( index ) {
			$( 'input', this ).removeAttr( 'disabled' );
			$( 'label', this ).css( 'cursor', 'pointer' );
		} );
	}

	set_slider_value( parent_selector, value, unit, display ) {
		var display_value = value;

		if ( undefined !== display ) {
			display_value = display;
		}

		$( '.slider', parent_selector ).slider( 'value', parseInt( value ) );
		$( '.amount', parent_selector ).html( wpmdb.functions.wpmdb_add_commas( display_value ) + ' ' + unit );
	}

	set_pause_resume_button( event, instance ) {
		if ( true === this.migration_paused ) {
			this.migration_paused = false;
			this.doing_ajax = true;

			wpmdb.current_migration.setState( this.previous_progress_title, this.previous_progress_text_primary, 'active' );
			$( '.pause-resume' ).html( wpmdb_strings.pause );

			// Resume the timer
			wpmdb.current_migration.resumeTimer();

			wpmdb.functions.execute_next_step( instance );
		} else {
			this.migration_paused = true;
			this.doing_ajax = false;
			this.paused_text = wpmdb_strings.migration_paused;
			this.previous_progress_title = $( '.progress-title' ).html();
			this.previous_progress_text_primary = $( '.progress-text', '.progress-wrapper-primary' ).html();
			this.previous_progress_text_secondary = $( '.progress-text', '.progress-wrapper-secondary ' ).html();

			if ( 'find_replace' === this.migration_intent ) {
				this.paused_text = wpmdb_strings.find_replace_paused;
			}

			wpmdb.current_migration.setState( this.paused_text, wpmdb_strings.completing_current_request, null );
			$( 'body' ).off( 'click', '.pause-resume' ); // Is re-bound at execute_next_step when migration is finally paused
			$( 'body' ).off( 'click', '.cancel' ); // Is re-bound at execute_next_step when migration is finally paused
		}
	}

	/**
	 * Filter temporary tables out of wpmdb.functions.create_table_select().
	 *
	 * @param exclude
	 * @param table_name
	 * @returns {bool}
	 */
	filter_temp_tables( exclude, table_name ) {
		var temp_prefix = wpmdb_data.this_temp_prefix;

		if ( 'pull' === wpmdb.functions.wpmdb_migration_type() && 'undefined' !== typeof wpmdb.common.connection_data && 'undefined' !== typeof wpmdb.common.connection_data.temp_prefix ) {
			temp_prefix = wpmdb.common.connection_data.temp_prefix;
		}

		if ( temp_prefix === table_name.substring( 0, temp_prefix.length ) ) {
			return true;
		}

		return exclude;
	}

	get_table_prefix( value, args ) {
		return $( '.table-select-wrap .table-prefix' ).text();
	}

	lock_replace_url( lock ) {
		if ( true === lock ) {
			$( '.replace-row.pin .replace-right-col input[type="text"]' ).attr( 'readonly', 'readonly' );
			$( '.replace-row.pin .arrow-col' ).addClass( 'disabled' );
		} else {
			$( '.replace-row.pin .replace-right-col input[type="text"]' ).removeAttr( 'readonly' );
			$( '.replace-row.pin .arrow-col' ).removeClass( 'disabled' );
		}
	}

	set_connection_data( data ) {
		window.wpmdb.common.previous_connection_data = wpmdb.common.connection_data;
		window.wpmdb.common.connection_data = data;
		$.wpmdb.do_action( 'wpmdb_connection_data_updated', data );
	}

	/**
	 * Returns formatted info for the Max Request Size slider.
	 *
	 * @param value
	 * @return object
	 */
	get_max_request_display_info( value ) {
		var display_info = {};

		display_info.unit = 'MB';
		display_info.amount = (value / 1024).toFixed( 2 );

		return display_info;
	}

	establish_remote_connection_from_saved_profile() {
		var action = wpmdb.functions.wpmdb_migration_type();
		var connection_info = $.trim( $( '.pull-push-connection-info' ).val() ).split( '\n' );
		if ( 'undefined' === typeof wpmdb_default_profile ||
		     true === wpmdb_default_profile ||
		     'savefile' === action ||
		     'find_replace' === action ||
		     'import' === action ||
		     this.doing_ajax ||
		     !wpmdb_data.is_pro ) {
			return;
		}

		this.doing_ajax = true;
		this.disable_export_type_controls();

		$( '.connection-status' ).html( wpmdb_strings.establishing_remote_connection );
		$( '.connection-status' ).removeClass( 'notification-message error-notice migration-error' );
		$( '.connection-status' ).append( this.ajax_spinner );

		var intent = wpmdb.functions.wpmdb_migration_type();
		// Hack to keep object scope
		const self = this;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'json',
			cache: false,
			data: {
				action: 'wpmdb_verify_connection_to_remote_site',
				url: connection_info[ 0 ],
				key: connection_info[ 1 ],
				intent: intent,
				nonce: wpmdb_data.nonces.verify_connection_to_remote_site,
				convert_post_type_selection: wpmdb_convert_post_type_selection,
				profile: wpmdb_data.profile
			},
			error( jqXHR, textStatus, errorThrown ){
				$( '.connection-status' ).html( self.get_ajax_errors( jqXHR.responseText, '(#102)', jqXHR ) );
				$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
				$( '.ajax-spinner' ).remove();
				self.doing_ajax = false;
				self.enable_export_type_controls();
			},
			success( data ) {
				$( '.ajax-spinner' ).remove();
				self.doing_ajax = false;
				self.enable_export_type_controls();

				if ( 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
					$( '.connection-status' ).html( data.body );
					$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );

					if ( data.body.indexOf( '401 Unauthorized' ) > -1 ) {
						$( '.basic-access-auth-wrapper' ).show();
					}

					return;
				}

				if ( true === wpmdb.functions.maybe_show_mst_warning( data ) ) {
					$( '.connection-status' ).hide();
					return;
				}

				self.maybe_show_ssl_warning( connection_info[ 0 ], connection_info[ 1 ], data.scheme );
				wpmdb.functions.maybe_show_prefix_notice( data.prefix );

				$( '.pull-push-connection-info' ).addClass( 'temp-disabled' );
				$( '.pull-push-connection-info' ).attr( 'readonly', 'readonly' );
				$( '.connect-button' ).hide();

				$( '.connection-status' ).hide();
				$( '.step-two' ).show();
				self.connection_established = true;
				self.set_connection_data( data );
				self.move_connection_info_box();

				self.maybe_show_mixed_cased_table_name_warning();

				var loaded_tables = '';
				if ( false === wpmdb_default_profile && 'undefined' !== typeof wpmdb_loaded_tables ) {
					loaded_tables = wpmdb_loaded_tables;
				}

				self.$pull_select = wpmdb.functions.create_table_select( wpmdb.common.connection_data.tables, wpmdb.common.connection_data.table_sizes_hr, loaded_tables );
				var loaded_post_types = '';
				if ( false === wpmdb_default_profile && 'undefined' !== typeof wpmdb_loaded_post_types ) {
					if ( 'undefined' !== typeof data.select_post_types ) {
						$( '#exclude-post-types' ).attr( 'checked', 'checked' );
						$( '.post-type-select-wrap' ).show();
						loaded_post_types = data.select_post_types;
					} else {
						loaded_post_types = wpmdb_loaded_post_types;
					}
				}

				var $post_type_select = document.createElement( 'select' );
				$( $post_type_select ).attr( {
					multiple: 'multiple',
					name: 'select_post_types[]',
					id: 'select-post-types',
					class: 'multiselect'
				} );

				$.each( wpmdb.common.connection_data.post_types, function( index, value ) {
					var selected = $.inArray( value, loaded_post_types );
					if ( -1 !== selected || (true === wpmdb_convert_exclude_revisions && 'revision' !== value) ) {
						selected = ' selected="selected" ';
					} else {
						selected = ' ';
					}
					$( $post_type_select ).append( '<option' + selected + 'value="' + value + '">' + value + '</option>' );
				} );

				self.$pull_post_type_select = $post_type_select;

				var loaded_tables_backup = '';
				if ( false === wpmdb_default_profile && 'undefined' !== typeof wpmdb_loaded_tables_backup ) {
					loaded_tables_backup = wpmdb_loaded_tables_backup;
				}

				var $table_select_backup = document.createElement( 'select' );
				$( $table_select_backup ).attr( {
					multiple: 'multiple',
					name: 'select_backup[]',
					id: 'select-backup',
					class: 'multiselect'
				} );

				$.each( wpmdb.common.connection_data.tables, function( index, value ) {
					var selected = $.inArray( value, loaded_tables_backup );
					if ( -1 !== selected ) {
						selected = ' selected="selected" ';
					} else {
						selected = ' ';
					}
					$( $table_select_backup ).append( '<option' + selected + 'value="' + value + '">' + value + ' (' + wpmdb.common.connection_data.table_sizes_hr[ value ] + ')</option>' );
				} );

				self.$push_select_backup = $table_select_backup;

				if ( 'pull' === wpmdb.functions.wpmdb_migration_type() ) {
					$.wpmdb.do_action( 'wpmdb_update_pull_table_select' );
					$( '#select-post-types' ).remove();
					$( '.exclude-post-types-warning' ).after( self.$pull_post_type_select );
					$( '#select-backup' ).remove();
					$( '.backup-tables-wrap' ).prepend( self.$pull_select_backup );
					$( '.table-prefix' ).html( data.prefix );
					$( '.uploads-dir' ).html( wpmdb_data.this_uploads_dir );
				} else {
					$( '#select-backup' ).remove();
					$( '.backup-tables-wrap' ).prepend( self.$push_select_backup );
				}

				$.wpmdb.do_action( 'verify_connection_to_remote_site', wpmdb.common.connection_data );
			}
		} );
	}

	/**
	 * Main method that shows migration progress in the UI
	 * @param current_row
	 * @param primary_keys
	 * @param iterator
	 */
	migrate_table_recursive( current_row, primary_keys, iterator ) {
		let i = iterator || 0;

		if ( i >= this.tables_to_migrate.length ) {

			if ( 'upload' === this.stage && wpmdb.current_migration.model.getStageItems( 'find_replace' ).length ) {
				this.stage = 'find_replace';
				this.tables_to_migrate = wpmdb.current_migration.model.getStageItems( 'find_replace', 'name' );
				this.tables_to_migrate = this.tables_to_migrate.map( function( table ) {
					return '_mig_' + table;
				} );
				i = 0;
			} else if ( 'backup' === this.stage ) {

				if ( -1 !== $.inArray( this.migration_intent, [ 'push', 'pull' ] ) ) {
					this.stage = 'migrate';
				} else if ( 'import' === this.migration_intent ) {
					this.stage = 'upload';
				} else {
					this.stage = this.migration_intent;
				}

				wpmdb.current_migration.model.setActiveStage( this.stage );

				if ( 'find_replace' !== this.stage && 'migrate' !== this.stage ) {
					wpmdb.functions.wpmdb_call_next_hook();
					return;
				}

				i = 0;

				// should get from model
				this.tables_to_migrate = wpmdb.functions.get_tables_to_migrate( null, null );

			} else {
				$( '.progress-label' ).removeClass( 'label-visible' );

				wpmdb.common.hooks = $.wpmdb.apply_filters( 'wpmdb_before_migration_complete_hooks', wpmdb.common.hooks );
				wpmdb.common.hooks.push( wpmdb.functions.migration_complete );
				wpmdb.common.hooks.push( wpmdb.functions.wpmdb_flush );
				wpmdb.common.hooks = $.wpmdb.apply_filters( 'wpmdb_after_migration_complete_hooks', wpmdb.common.hooks );
				wpmdb.common.hooks.push( wpmdb.functions.migration_complete_events );
				wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
				wpmdb.functions.execute_next_step();
				return;
			}
		}

		var last_table = 0;
		if ( i === (this.tables_to_migrate.length - 1) ) {
			last_table = 1;
		}

		var gzip = 0;
		if ( -1 !== $.inArray( this.migration_intent, [
				'push',
				'pull'
			] ) && 1 === parseInt( wpmdb.common.connection_data.gzip ) ) {
			gzip = 1;
		}

		var request_data = {
			action: 'wpmdb_migrate_table',
			migration_state_id: wpmdb.migration_state_id,
			table: this.tables_to_migrate[ i ],
			stage: this.stage,
			current_row: current_row,
			last_table: last_table,
			primary_keys: primary_keys,
			gzip: gzip,
			nonce: wpmdb_data.nonces.migrate_table
		};

		if ( -1 !== $.inArray( this.migration_intent, [ 'push', 'pull' ] ) ) {
			request_data.bottleneck = wpmdb.common.connection_data.bottleneck;
			request_data.prefix = wpmdb.common.connection_data.prefix;
		}

		if ( wpmdb.common.connection_data && wpmdb.common.connection_data.path_current_site && wpmdb.common.connection_data.domain ) {
			request_data.path_current_site = wpmdb.common.connection_data.path_current_site;
			request_data.domain_current_site = wpmdb.common.connection_data.domain;
		}

		this.doing_ajax = true;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			timeout: 0,
			data: request_data,
			error: ( jqXHR, textStatus, errorThrown ) => {
				var progress_text = wpmdb_strings.table_process_problem + ' ' + this.tables_to_migrate[ i ] + '<br /><br />' + wpmdb_strings.status + ': ' + jqXHR.status + ' ' + jqXHR.statusText + '<br /><br />' + wpmdb_strings.response + ':<br />' + jqXHR.responseText;
				wpmdb.current_migration.setState( wpmdb_strings.migration_failed, progress_text, 'error' );

				this.doing_ajax = false;
				console.log( jqXHR );
				console.log( textStatus );
				console.log( errorThrown );
				wpmdb.common.migration_error = true;
				wpmdb.functions.migration_complete_events();

			},
			success: ( data ) => {
				this.doing_ajax = false;
				data = $.trim( data );
				var row_information = wpmdb.functions.wpmdb_parse_json( data );
				var error_text = '';

				if ( false === row_information || null === row_information ) {

					// should update model
					if ( '' === data || null === data ) {
						error_text = wpmdb_strings.table_process_problem_empty_response + ' ' + this.tables_to_migrate[ i ];
					} else {
						error_text = this.get_ajax_errors( data, null, null );
					}

					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, error_text, 'error' );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();
					return;
				}

				if ( 'undefined' !== typeof row_information.wpmdb_error && 1 === row_information.wpmdb_error ) {
					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, row_information.body, 'error' );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();
					return;
				}

				var item_name = this.tables_to_migrate[ i ];
				if ( 'import' === this.migration_intent && 'find_replace' === this.stage ) {
					item_name = item_name.replace( wpmdb_data.this_temp_prefix, '' );
				}

				//successful iteration
				wpmdb.current_migration.setText();
				wpmdb.current_migration.model.getStageModel( this.stage ).setItemRowsTransferred( item_name, row_information.current_row );

				// We need the returned file name for delivery or display to the user.
				if ( 1 === last_table && 'savefile' === this.migration_intent ) {
					if ( 'undefined' !== typeof row_information.dump_filename ) {
						this.dump_filename = row_information.dump_filename;
					}
					if ( 'undefined' !== typeof row_information.dump_path ) {
						this.dump_path = row_information.dump_path;
					}
				}

				if ( -1 === parseInt( row_information.current_row ) ) {
					i++;
					row_information.current_row = '';
					row_information.primary_keys = '';
				}

				wpmdb.common.next_step_in_migration = {
					fn: wpmdb.functions.migrate_table_recursive,
					args: [ row_information.current_row, row_information.primary_keys, i ]
				};
				wpmdb.functions.execute_next_step();
			}
		} );

	}

	migration_complete_events() {
		if ( false === wpmdb.common.migration_error ) {
			if ( '' === wpmdb.common.non_fatal_errors ) {
				if ( 'savefile' !== this.migration_intent && true === $( '#save_computer' ).is( ':checked' ) ) {
					wpmdb.current_migration.setText();
				}

				this.completed_msg = this.completed_msg + '&nbsp;<div class="dashicons dashicons-yes"></div>';

				if ( true === this.migration_cancelled ) {
					var cancel_success = wpmdb_strings.migration_cancelled_success;

					if ( 'find_replace' === this.migration_intent ) {
						cancel_success = wpmdb_strings.find_replace_cancelled_success;
					}

					wpmdb.current_migration.setState( this.completed_msg, cancel_success, 'cancelled' );
				} else {
					wpmdb.current_migration.setState( this.completed_msg, '', 'complete' );
				}

			} else {
				wpmdb.current_migration.setState( wpmdb_strings.completed_with_some_errors, wpmdb.common.non_fatal_errors, 'error' );
			}
		}

		$( '.migration-controls' ).addClass( 'hidden' );

		// reset migration variables so consecutive migrations work correctly
		wpmdb.common.hooks = [];
		wpmdb.common.call_stack = [];
		wpmdb.common.migration_error = false;
		this.currently_migrating = false;
		this.migration_completed = true;
		this.migration_paused = false;
		this.migration_cancelled = false;
		this.doing_ajax = false;
		wpmdb.common.non_fatal_errors = '';
		this.tables_to_migrate = [];

		$( '.progress-label' ).remove();
		$( '.migration-progress-ajax-spinner' ).remove();
		$( '.close-progress-content' ).show();
		$( '#overlay' ).css( 'cursor', 'pointer' );
		wpmdb.current_migration.model.setMigrationComplete();
	}

	migration_complete() {

		$( '.migration-controls' ).addClass( 'hidden' );

		if ( 'savefile' === this.migration_intent ) {
			this.currently_migrating = false;
			var migrate_complete_text = wpmdb_strings.migration_complete;
			if ( $( '#save_computer' ).is( ':checked' ) ) {
				var url = wpmdb_data.this_download_url + encodeURIComponent( this.dump_filename );
				if ( $( '#gzip_file' ).is( ':checked' ) ) {
					url += '&gzip=1';
				}
				window.location = url;
			} else {
				migrate_complete_text = wpmdb_strings.completed_dump_located_at + ' ' + this.dump_path;
			}

			if ( false === wpmdb.common.migration_error ) {

				wpmdb.functions.migration_complete_events();
				wpmdb.current_migration.setState( this.completed_msg, migrate_complete_text, 'complete' );

			}

		} else { // rename temp tables, delete old tables

			wpmdb.current_migration.setState( null, wpmdb_strings.finalizing_migration, 'finalizing' );

			var request_data = {
				action: 'wpmdb_finalize_migration',
				migration_state_id: wpmdb.migration_state_id,
				tables: this.tables_to_migrate.join( ',' ),
				nonce: wpmdb_data.nonces.finalize_migration
			};

			if ( -1 !== $.inArray( this.migration_intent, [ 'push', 'pull' ] ) ) {
				request_data.prefix = wpmdb.common.connection_data.prefix;
			}

			this.doing_ajax = true;
			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: request_data,
				error: ( jqXHR, textStatus, errorThrown ) => {
					this.doing_ajax = false;
					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, wpmdb_strings.finalize_tables_problem, 'error' );

					alert( jqXHR + ' : ' + textStatus + ' : ' + errorThrown );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: ( data ) => {
					this.doing_ajax = false;
					if ( '1' !== $.trim( data ) ) {
						wpmdb.current_migration.setState( wpmdb_strings.migration_failed, data, 'error' );

						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						return;
					}
					wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
					wpmdb.functions.execute_next_step();
				}
			} );
		}
	}

	wpmdb_flush() {
		if ( 'savefile' !== this.migration_intent ) {
			wpmdb.current_migration.setText( wpmdb_strings.flushing );
			this.doing_ajax = true;
			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_flush',
					migration_state_id: wpmdb.migration_state_id,
					nonce: wpmdb_data.nonces.flush
				},
				error: ( jqXHR, textStatus, errorThrown ) => {
					this.doing_ajax = false;
					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, wpmdb_strings.flush_problem, 'error' );

					alert( jqXHR + ' : ' + textStatus + ' : ' + errorThrown );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: ( data ) => {
					this.doing_ajax = false;
					if ( '1' !== $.trim( data ) ) {
						wpmdb.current_migration.setState( wpmdb_strings.migration_failed, data, 'error' );

						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						return;
					}
					wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
					wpmdb.functions.execute_next_step();
				}
			} );
		}
	}

	execute_next_step() {

		// if delay is set, set a timeout for delay to recall this function, then return
		if ( 0 < this.delay_between_requests && false === this.flag_skip_delay ) {
			setTimeout( function() {
				this.flag_skip_delay = true;
				wpmdb.functions.execute_next_step();
			}, this.delay_between_requests );
			return;
		} else {
			this.flag_skip_delay = false;
		}

		if ( true === this.migration_paused ) {
			$( '.migration-progress-ajax-spinner' ).hide();

			// Pause the timer
			wpmdb.current_migration.pauseTimer();

			var pause_text = '';
			if ( true === this.is_auto_pause_before_finalize ) {
				pause_text = wpmdb_strings.paused_before_finalize;
				this.is_auto_pause_before_finalize = false;

				if ( 'find_replace' === wpmdb.functions.wpmdb_migration_type() ) {
					pause_text = wpmdb_strings.find_replace_paused_before_finalize;
				}
			} else {
				pause_text = wpmdb_strings.paused;
			}

			wpmdb.current_migration.setState( null, pause_text, 'paused' );

			// Re-bind Pause/Resume button to Resume when we are finally Paused
			$( 'body' ).on( 'click', '.pause-resume', function( event ) {
				this.set_pause_resume_button( event );
			} );
			$( 'body' ).on( 'click', '.cancel', function( event ) {
				this.cancel_migration( event );
			} );
			$( '.pause-resume' ).html( wpmdb_strings.resume );

		} else if ( true === this.migration_cancelled ) {
			this.migration_intent = wpmdb.functions.wpmdb_migration_type();

			var progress_msg;

			if ( 'savefile' === this.migration_intent ) {
				progress_msg = wpmdb_strings.removing_local_sql;
			} else if ( 'pull' === this.migration_intent ) {
				if ( 'backup' === this.stage ) {
					progress_msg = wpmdb_strings.removing_local_backup;
				} else {
					progress_msg = wpmdb_strings.removing_local_temp_tables;
				}
			} else if ( 'push' === this.migration_intent ) {
				if ( 'backup' === this.stage ) {
					progress_msg = wpmdb_strings.removing_remote_sql;
				} else {
					progress_msg = wpmdb_strings.removing_remote_temp_tables;
				}
			}
			wpmdb.current_migration.setText( progress_msg );

			var request_data = {
				action: 'wpmdb_cancel_migration',
				migration_state_id: wpmdb.migration_state_id,
				nonce: wpmdb_data.nonces.cancel_migration
			};

			this.doing_ajax = true;

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: request_data,
				error: ( jqXHR, textStatus, errorThrown ) => {
					wpmdb.current_migration.setState( wpmdb_strings.migration_cancellation_failed, wpmdb_strings.manually_remove_temp_files + '<br /><br />' + wpmdb_strings.status + ': ' + jqXHR.status + ' ' + jqXHR.statusText + '<br /><br />' + wpmdb_strings.response + ':<br />' + jqXHR.responseText, 'error' );
					console.log( jqXHR );
					console.log( textStatus );
					console.log( errorThrown );
					this.doing_ajax = false;
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: ( data ) => {
					this.doing_ajax = false;
					data = $.trim( data );

					if ( ('push' === this.migration_intent && '1' !== data) || ('push' !== this.migration_intent && '' !== data) ) {

						if ( 'undefined' !== typeof data && 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
							data = data.wpmdb_error;
						}

						wpmdb.current_migration.setState( wpmdb_strings.migration_cancellation_failed, data, 'error' );
						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						return;
					}

					this.completed_msg = wpmdb_strings.migration_cancelled;

					if ( 'find_replace' === this.migration_intent ) {
						this.completed_msg = wpmdb_strings.find_replace_cancelled;
					}

					wpmdb.functions.migration_complete_events();
					wpmdb.current_migration.setStatus( 'cancelled' );
				}
			} );
		} else {
			wpmdb.common.next_step_in_migration.fn.apply( null, wpmdb.common.next_step_in_migration.args );
		}
	}

	maybe_show_prefix_notice( prefix ) {
		var $prefix_notice = $( '.prefix-notice' );

		$prefix_notice.hide();

		if ( prefix !== wpmdb_data.this_prefix ) {
			$( '.remote-prefix' ).html( prefix );
			this.show_prefix_notice = true;
			$prefix_notice.show();
		}
	}

	maybe_show_select_table_notice() {

		// check that they've selected some tables to migrate
		if ( $( '#migrate-selected' ).is( ':checked' ) && null === $( '#select-tables' ).val() ) {
			if ( 'import' !== wpmdb.functions.wpmdb_migration_type() ) {
				alert( wpmdb_strings.please_select_one_table );
				return true;
			} else {
				if ( $( '#import-find-replace' ).is( ':checked' ) && $( '#select-tables' ).is( ':visible' ) ) {
					alert( wpmdb_strings.please_select_one_table_import );
					return true;
				}
			}
		}

		// check that they've selected some tables to backup
		if ( 'savefile' !== wpmdb.functions.wpmdb_migration_type() && $( '#backup-manual-select' ).is( ':checked' ) && null === $( '#select-backup' ).val() ) {
			alert( wpmdb_strings.please_select_one_table_backup );
			return true;
		}

		return false;
	}

	remove_protocol( url ) {
		return url.replace( /^https?:/i, '' );
	}

	create_table_select( tables, table_sizes_hr, selected_tables ) {
		var $table_select = document.createElement( 'select' );
		$( $table_select ).attr( {
			multiple: 'multiple',
			name: 'select_tables[]',
			id: 'select-tables',
			class: 'multiselect'
		} );

		if ( 0 < tables.length ) {
			$.each( tables, function( index, table ) {
				if ( $.wpmdb.apply_filters( 'wpmdb_exclude_table', false, table ) ) {
					return;
				}

				var selected = ' ';
				if ( undefined !== selected_tables && null !== selected_tables && 0 < selected_tables.length && -1 !== $.inArray( table, selected_tables ) ) {
					selected = ' selected="selected" ';
				}

				var size = '';
				if ( 0 !== table_sizes_hr.length ) {
					size = ' (' + table_sizes_hr[ table ] + ')';
				}

				$( $table_select ).append( '<option' + selected + 'value="' + table + '">' + table + size + '</option>' );
			} );
		}

		return $table_select;
	}

	/**
	 * Returns tables selected for migration.
	 *
	 * @returns {array}
	 *
	 * Also handler for wpmdb_get_tables_to_migrate filter, disregards input values as it is the primary source.
	 */
	get_tables_to_migrate() {
		var tables = [];
		var mig_type = wpmdb.functions.wpmdb_migration_type();
		var table_intent = $( 'input[name=table_migrate_option]:checked' ).val();

		// Grab tables as per what the user has selected from the multiselect box or all prefixed tables.
		if ( 'migrate_select' === table_intent ) {
			tables = $( '#select-tables' ).val();
		} else {
			if ( 'pull' !== mig_type && 'undefined' !== typeof wpmdb_data.this_prefixed_tables ) {
				tables = wpmdb_data.this_prefixed_tables;
			} else if ( 'pull' === mig_type && 'undefined' !== typeof wpmdb.common.connection_data && 'undefined' !== typeof wpmdb.common.connection_data.prefixed_tables ) {
				tables = wpmdb.common.connection_data.prefixed_tables;
			}
		}

		return tables;
	}

	update_migrate_button_text() {
		var migration_intent = wpmdb.functions.wpmdb_migration_type();
		var save_string = ($( '#save-migration-profile' ).is( ':checked' )) ? '_save' : '';
		var migrate_string = 'migrate_button_' + (('savefile' === migration_intent) ? 'export' : migration_intent) + save_string;
		$( '.migrate-db .button-primary' ).val( wpmdb_strings[ migrate_string ] );
	}

	// fired when the connection info box changes (e.g. gets pasted into)
	connection_box_changed() {
		var $this = $( '.pull-push-connection-info' );

		if ( -1 === $.inArray( wpmdb.functions.wpmdb_migration_type(), [ 'push', 'pull' ] ) ||
		     (this.doing_ajax || $( $this ).hasClass( 'temp-disabled' )) && false === wpmdb.force_reconnect ) {
			return;
		}

		wpmdb.force_reconnect = false;
		var data = $( '.pull-push-connection-info' ).val();

		var connection_info = $.trim( data ).split( '\n' );
		var error = false;
		var error_message = '';

		if ( '' === connection_info ) {
			error = true;
			error_message = wpmdb_strings.connection_info_missing;
		}

		// attempt to format the connection info from a single line
		if ( 1 === connection_info.length && !error ) {
			var connection_words = $.trim( data ).split( ' ' );
			if ( 2 === connection_words.length ) {
				connection_info = connection_words;
			}
		}

		if ( 2 !== connection_info.length && !error ) {
			error = true;
			error_message = wpmdb_strings.connection_info_incorrect;
		}

		if ( !error && !this.validate_url( connection_info[ 0 ] ) ) {
			error = true;
			error_message = wpmdb_strings.connection_info_url_invalid;
		}

		var key_length = 0;

		if ( 'undefined' !== typeof connection_info[ 1 ] ) {
			key_length = connection_info[ 1 ].length;
		}

		if ( !error && 32 !== key_length && 40 !== key_length ) {
			error = true;
			error_message = wpmdb_strings.connection_info_key_invalid;
		}

		if ( !error && connection_info[ 0 ] === wpmdb_data.connection_info[ 0 ] ) {
			error = true;
			error_message = wpmdb_strings.connection_info_local_url;
		}

		if ( !error && connection_info[ 1 ] === wpmdb_data.connection_info[ 1 ] ) {
			error = true;
			error_message = wpmdb_strings.connection_info_local_key;
		}
		if ( error ) {
			$( '.connection-status' ).html( error_message );
			$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
			return;
		}

		var new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];

		// If connection info is a single line
		if ( 1 === $.trim( data ).split( '\n' ).length ) {

			// Repopulate the input with the info on two lines
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
		}

		if ( false === wpmdb_data.openssl_available ) {
			connection_info[ 0 ] = connection_info[ 0 ].replace( 'https://', 'http://' );
			new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
		}

		this.show_prefix_notice = false;
		this.doing_ajax = true;
		this.disable_export_type_controls();

		if ( $( '.basic-access-auth-wrapper' ).is( ':visible' ) ) {
			connection_info[ 0 ] = connection_info[ 0 ].replace( /\/\/(.*)@/, '//' );
			connection_info[ 0 ] = connection_info[ 0 ].replace( '//', '//' + encodeURIComponent( $.trim( $( '.auth-username' ).val() ) ) + ':' + encodeURIComponent( $.trim( $( '.auth-password' ).val() ) ) + '@' );
			new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
			$( '.basic-access-auth-wrapper' ).hide();
		}

		$( '.step-two' ).hide();
		$( '.ssl-notice' ).hide();
		$( '.prefix-notice' ).hide();
		$( '.connection-status' ).show();

		$( '.connection-status' ).html( wpmdb_strings.establishing_remote_connection );
		$( '.connection-status' ).removeClass( 'notification-message error-notice migration-error' );
		$( '.connection-status' ).append( this.ajax_spinner );

		var intent = wpmdb.functions.wpmdb_migration_type();

		this.profile_name_edited = false;

		return $.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'json',
			cache: false,
			data: {
				action: 'wpmdb_verify_connection_to_remote_site',
				url: connection_info[ 0 ],
				key: connection_info[ 1 ],
				intent: intent,
				nonce: wpmdb_data.nonces.verify_connection_to_remote_site
			},
			error: ( jqXHR, textStatus, errorThrown ) => {
				$( '.connection-status' ).html( this.get_ajax_errors( jqXHR.responseText, '(#100)', jqXHR ) );
				$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
				$( '.ajax-spinner' ).remove();
				this.doing_ajax = false;
				this.enable_export_type_controls();
			},
			success: ( data ) => {
				$( '.ajax-spinner' ).remove();
				this.doing_ajax = false;
				this.enable_export_type_controls();

				if ( 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
					$( '.connection-status' ).html( data.body );
					$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );

					if ( data.body.indexOf( '401 Unauthorized' ) > -1 ) {
						$( '.basic-access-auth-wrapper' ).show();
					}

					if ( !$( '.pull-push-connection-info' ).hasClass( 'temp-disabled' ) && !$( '.connect-button' ).is( ':visible' ) ) {
						$( '.pull-push-connection-info' ).removeAttr( 'readonly' );
						$( '.connect-button' ).show();
					}

					return;
				}

				if ( true === wpmdb.functions.maybe_show_mst_warning( data ) ) {
					$( '.connection-status' ).hide();
					return;
				}

				this.maybe_show_ssl_warning( connection_info[ 0 ], connection_info[ 1 ], data.scheme );

				var profile_name = this.get_domain_name( data.url );
				$( '.create-new-profile' ).val( profile_name );

				$( '.pull-push-connection-info' ).addClass( 'temp-disabled' );
				$( '.pull-push-connection-info' ).attr( 'readonly', 'readonly' );
				$( '.connect-button' ).hide();

				$( '.connection-status' ).hide();
				$( '.step-two' ).show();

				wpmdb.functions.maybe_show_prefix_notice( data.prefix );

				this.connection_established = true;
				this.set_connection_data( data );
				this.move_connection_info_box();
				this.change_replace_values();

				this.maybe_show_mixed_cased_table_name_warning();

				this.refresh_table_selects( null, null, this );

				this.$push_select_backup = $( this.$pull_select ).clone();
				$( this.$push_select_backup ).attr( {
					name: 'select_backup[]',
					id: 'select-backup'
				} );

				var $post_type_select = document.createElement( 'select' );
				$( $post_type_select ).attr( {
					multiple: 'multiple',
					name: 'select_post_types[]',
					id: 'select-post-types',
					class: 'multiselect'
				} );

				$.each( wpmdb.common.connection_data.post_types, function( index, value ) {
					$( $post_type_select ).append( '<option value="' + value + '">' + value + '</option>' );
				} );

				this.$pull_post_type_select = $post_type_select;

				$( '#new-path-missing-warning, #new-url-missing-warning' ).hide();

				if ( 'pull' === wpmdb.functions.wpmdb_migration_type() ) {
					$( '#new-url' ).val( this.remove_protocol( wpmdb_data.this_url ) );
					$( '#new-path' ).val( wpmdb_data.this_path );
					if ( 'true' === wpmdb_data.is_multisite ) {
						$( '#new-domain' ).val( wpmdb_data.this_domain );
						$( '.replace-row.pin .old-replace-col input[type="text"]' ).val( this.remove_protocol( data.url ) );
					}
					$( '#old-url' ).val( this.remove_protocol( data.url ) );
					$( '#old-path' ).val( data.path );

					$.wpmdb.do_action( 'wpmdb_update_pull_table_select' );
					$( '#select-post-types' ).remove();
					$( '.exclude-post-types-warning' ).after( this.$pull_post_type_select );
					wpmdb.functions.exclude_post_types_warning();
					$( '.table-prefix' ).html( data.prefix );
					$( '.backup-table-prefix' ).html( wpmdb_data.site_details.prefix );
					$( '.uploads-dir' ).html( wpmdb_data.this_uploads_dir );
				} else {
					$( '#new-url' ).val( this.remove_protocol( data.url ) );
					$( '#new-path' ).val( data.path );

					if ( 'true' === wpmdb_data.is_multisite ) {
						$( '.replace-row.pin .old-replace-col input[type="text"]' ).val( this.remove_protocol( wpmdb_data.this_url ) );
					}
					$.wpmdb.do_action( 'wpmdb_update_push_table_select' );
					$( '#select-backup' ).remove();
					$( '.backup-tables-wrap' ).prepend( this.$push_select_backup );
				}

				wpmdb.common.next_step_in_migration = {
					fn: $.wpmdb.do_action,
					args: [ 'verify_connection_to_remote_site', wpmdb.common.connection_data ]
				};
				wpmdb.functions.execute_next_step();
			}
		} );
	}
}



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/helpers/wpmdbGlobals.js